import { InlineMath, BlockMath } from "react-katex";
import FractionInput from "../../../../components/inputs/FractionInput";
import {
  formatLatexPreview
} from "../../../../components/inputs/FractionInput";


function getRandomFromArray(array) {
  const index = Math.floor(Math.random() * array.length);
  return array[index];
}

function getRandomInt(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

export function generateTask() {
  const k = getRandomFromArray([3, 4, 6, 7, 8, 9, 11]);
  const A = getRandomInt(50, 200);
  const B = getRandomInt(A + 200, A + 600);

  const a1 = A + (k - (A % k)) % k; // pierwsza liczba ≥ A podzielna przez k
  const an = B - (B % k); // ostatnia liczba ≤ B podzielna przez k

  const n = Math.floor((an - a1) / k) + 1;

return {
  type: "FindCountDivisibleTask",
  data: { A, B, k },
  answer: n,
};

}


export function renderTask({ data }) {
  const { A, B, k } = data;

  return (
    <div style={{ marginTop: "1rem", marginBottom: "1rem" }}>
      Ile jest liczb podzielnych przez <InlineMath math={`${k}`} /> w przedziale od{" "}
      <InlineMath math={`${A}`} /> do <InlineMath math={`${B}`} />?
    </div>
  );
}



export function renderAnswer({ answer }) {
  return <InlineMath math={`${answer}`} />
}

export function renderUserAnswer(userAnswer) {
  if (!userAnswer || typeof userAnswer !== "object" || !userAnswer.raw) {
    return <i>(brak odpowiedzi)</i>;
  }

  return <InlineMath math={formatLatexPreview(userAnswer.raw, "n")} />;
}

export function checkAnswer({ answer }, userAnswer) {
  const parsed = userAnswer?.parsed;
  if (parsed == null || isNaN(parsed)) return false;
  return Number(parsed) === answer;
}


export function renderExplanation({ data }) {
  const { A, B, k } = data;


  const a1 = A + (k - (A % k)) % k; // pierwsza liczba ≥ A podzielna przez k
  const an = B - (B % k);           // ostatnia liczba ≤ B podzielna przez k
  const n = Math.floor((an - a1) / k) + 1;

  return (
    <div className="space-y-4">
      <p>
        <b>Krok 1:</b> Wyznaczamy pierwszą liczbę większą lub równą{" "}
        <InlineMath math={String(A)} /> podzielną przez{" "}
        <InlineMath math={String(k)} />:
      </p>
      <BlockMath math={`a_1 = ${a1}`} />

      <p>
        <b>Krok 2:</b> Wyznaczamy ostatnią liczbę mniejszą lub równą{" "}
        <InlineMath math={String(B)} /> podzielną przez{" "}
        <InlineMath math={String(k)} />:
      </p>
      <BlockMath math={`a_n = ${an}`} />

      <p>
        <b>Krok 3:</b> Obliczamy liczbę wyrazów ciągu arytmetycznego. Wzór ogólny:
      </p>
      <BlockMath math={`a_n = a_1 + (n - 1)r`} />
      <p>Podstawiamy <InlineMath math={`r = ${k}`} /> i przekształcamy do postaci:</p>
      <BlockMath math={`n = \\frac{a_n - a_1}{${k}} + 1`} />
      <p>Podstawiamy wartości:</p>
      <BlockMath math={`n = \\frac{${an} - ${a1}}{${k}} + 1 = ${n}`} />
    </div>
  );
}



export function renderInput(_, userAnswer, onChange, disabled) {
  return (
    <div className="flex items-center gap-4">
      <span><InlineMath math="n =" /></span>
      <FractionInput
        value={userAnswer || ""}
        onChange={onChange}
        disabled={disabled}
        label="n"
      />
    </div>
  );
}
